/* ----------------------------------------------------------------------
   PP — Bundle-Builder ATC: Lade-Animation reparieren.

   Problem: bkMediaBundleApplyAtcButtonContent() in bk-media.js leert bei
   jedem Label-Update den kompletten Button (btn.removeChild auf alle
   Kinder). Dabei fliegen das interne contentElement und der
   .button__loader des custom-button-Elements (theme.js) aus dem DOM.
   Wenn runBundleAddToCart dann aria-busy="true" setzt, animiert
   custom-button nur noch detachte Referenzen — sichtbar passiert nichts.

   Fix: Label in das bestehende contentElement schreiben statt den Button
   zu leeren; der .button__loader bleibt erhalten und aria-busy zeigt
   wieder die drei pulsierenden Punkte (wie auf den Design-PDPs).

   MUSS nach bk-media.js geladen werden (beide defer = Reihenfolge).
   ---------------------------------------------------------------------- */
(function () {
  'use strict';

  function buildLabelNode(label, showLock) {
    var tpl = document.getElementById('bk-media-bundle-atc-lock-icon');
    if (showLock && tpl && tpl.content && tpl.content.childNodes.length) {
      var wrap = document.createElement('div');
      wrap.className = 'text-with-icon justify-center';
      wrap.appendChild(tpl.content.cloneNode(true));
      wrap.appendChild(document.createTextNode(label));
      return wrap;
    }
    return document.createTextNode(label);
  }

  function ppApplyAtcButtonContent(btn, text, showLock) {
    if (!btn || text == null) return;
    var label = String(text);
    var node = buildLabelNode(label, showLock);

    /* custom-button bereits upgegradet: nur ins contentElement schreiben. */
    var target = btn._contentElement;
    if (target && btn.contains(target)) {
      while (target.firstChild) target.removeChild(target.firstChild);
      target.appendChild(node);
      return;
    }

    /* Noch nicht upgegradet oder Struktur fehlt: Kinder ersetzen,
       einen evtl. vorhandenen Loader aber behalten. */
    var loader = btn.querySelector('.button__loader');
    while (btn.firstChild) btn.removeChild(btn.firstChild);
    btn.appendChild(node);
    if (loader) btn.appendChild(loader);
  }

  /* bk-media.js ist ein klassisches Skript — die Top-Level-Funktion liegt
     auf window und wird an den Call-Sites zur Laufzeit aufgelöst. */
  window.bkMediaBundleApplyAtcButtonContent = ppApplyAtcButtonContent;
})();
